import APIClient from '@/shared/http/clients/api'

const resourceName = 'atendimento'
const APICore = process.env.APIBaseURLCore

const GetConversations = (config = {}) => APIClient.get(`${APICore}/${resourceName}/conversas`, config)
const GetConversationMessages = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/conversas/${protocolo}`, config)
const GetUsenames = (config = {}) => APIClient.get(`${APICore}/${resourceName}/usuarios/usernames`, config)
const GetPersonDetails = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/conversas/${protocolo}/detalhes`, config)
const GetTipos = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/finalizacao/tiposFinalizacao`, config)
const GetQrCode = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/qrcode`, config)
const GetPages = (config = {}) => APIClient.get(`${APICore}/${resourceName}/paginas`, config)
const SendMessage = (protocolo, data, config = {}) => APIClient.post(`${APICore}/${resourceName}/conversas/${protocolo}/enviar-mensagem`, data, config)

const AtendimentoRepository = {
  GetQrCode,
  GetConversations,
  GetConversationMessages,
  GetPersonDetails,
  SendMessage,
  GetUsenames,
  GetTipos,
  GetPages
}

export default AtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/atendimento/atendimento.js